import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCcMxy7mG8YvQ9dfxzAN0OFX_oJEOW-14g",
    authDomain: "youtub-be.firebaseapp.com",
    projectId: "youtub-be",
    storageBucket: "youtub-be.appspot.com",
    messagingSenderId: "341003754354",
    appId: "1:341003754354:web:73b89bd1fc35fc27445beb"
  };

  firebase.initializeApp(firebaseConfig) 

  export default firebase.auth()
